import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default {
    data() {
        return {
            locale: LocService,
            currentDate: '',
            role: '',
            filter: '',
            slots: [],
            isVisibleAddUserToTerm: false,
            chooseUser: false,
            upHere: false,
            upIndex: -1,
            selectedSlot: null,
        }
    },
    methods: {
        load: load,
        deleteTraining: deleteTraining,
        reserveTrainingForUser: reserveTrainingForUser,
        openChooseUser: openChooseUser,
        activateDeactivate: activateDeactivate,
        getDataForTerm: getDataForTerm,
        deleteTrainingAndUsers: deleteTrainingAndUsers,
        editTraining: editTraining,
        getTrainings: getTrainings,
        deactiveTraining:deactiveTraining,
        activeTraining: activeTraining, 
        getRowStyle: getRowStyle

    },
    computed: {
        filteredSlots() {
            return this.slots.filter(item => {
                return  item.trainingType.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.startAt.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1;
            })
        }
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.chooseUser = false;
            _self.selectedSlot = null;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            _self.chooseUser = false;
            _self.reserveTrainingForUser(_self.selectedSlot.id, data.id, data.selectedTrainer)
        });
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.isVisibleAddUserToTerm = session.getConfig().canAddUserWithTerm;
        this.currentDate = this.$route.query.date
        this.load();
        this.getTrainings();
        this.role = session.getRole();
    },
}

function getDataForTerm(startAt, trainingType){
    let filteredList = this.trainings.filter( s => s.startAt === startAt && s.trainingType === trainingType)
    if(filteredList.length === 0) return "";
    var users = "<ul>";
    filteredList.forEach(t => {
        users += "<li>" + t.firstName +" " + t.lastName + " </li>";
    })
    users += "</ul>"
    return users;
}

function getTrainings() {
    AdminApiService.getTrainingsByDate(this.currentDate)
        .then((response) => {
            this.trainings = response.data
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reserveTrainingForUser(slotId, mUserid, selectedTrainer){
    let _self = this;
    let model = {
        slotId: slotId,
        trainer: selectedTrainer
    }
    AdminApiService.addTrainingFromAdmin(model, mUserid)
        .then((response) => {
            _self.selectedSlot = null;
            swal(LocService.t("label_success"), LocService.t("label_success_add_training"), 'success')
        })
        .catch((error) => {
            _self.selectedSlot = null;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')

        })
}

function load() {
    let _self = this;
    AdminApiService.getSlotByDate(this.currentDate)
        .then((response) => {
            _self.slots = response.data;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function openChooseUser(slot){
    this.selectedSlot = slot
    this.chooseUser = true;
}

function editTraining(training) {
    this.$router.push('edit-training?id=' + training.id)
}

function activeTraining(slot) {
    let _self = this;

    swal({
        title: LocService.t("label_are_you_sure"),
        text: LocService.t("label_are_you_sure_activate_term") + ": " + slot.date,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.activatedSlot(slot.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_term_activated"), 'success')
                _self.load()
            })
            .catch((error) => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function deactiveTraining(slot) {
    let _self = this;

    swal({
        title: LocService.t("label_are_you_sure"),
        text: LocService.t("label_are_you_sure_activate_term") + ": " + slot.date,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deactivatedSlot(slot.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_term_deactivated"), 'success')
                _self.load()
            })
            .catch((error) => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });

}

function deleteTraining(training) {
    let _self = this;

    swal({
        title: LocService.t("label_are_you_sure"),
        text: LocService.t("label_are_you_sure_delete_term")  + ": " + training.date,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText:  LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText:  LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteSlot(training.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_term_deleted"), 'success')
                _self.load()
            })
            .catch((error) => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function deleteTrainingAndUsers(training) {
    let _self = this;

    swal({
        title: LocService.t("label_are_you_sure"),
        text: LocService.t("label_are_you_sure_delete_term")  + ": " + training.date,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText:  LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText:  LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        swal({
            title: LocService.t("label_back_training"),
            text:  LocService.t("label_back_training_are_you_sure"),
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: LocService.t("label_no"),
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: LocService.t("label_yes"),
            customClass: 'swal2-warning'
        }).then(function () {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {});
            AdminApiService.deleteSlotAndUsers(training.id, true)
                .then((response) => {
                    swal(LocService.t("label_success"), LocService.t("label_term_deleted"), 'success')
                    _self.load()
                })
                .catch((error) => {
                    swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
                })
        }).catch(function () {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {});
            AdminApiService.deleteSlotAndUsers(training.id, false)
                .then((response) => {
                    swal(LocService.t("label_success"), LocService.t("label_term_deleted"), 'success')
                    _self.load()
                })
                .catch((error) => {
                    swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
                })
        });


    });
}

function getRowStyle(slot) {
    if(slot.deactivated){
        return "background: red; color: white; "
    }else {
        return "color: white;"
    }
}

function activateDeactivate(value){
    let _self = this;
    var isFiltered = this.filteredSlots.length !== this.slots.length;
    var messageActivate = isFiltered ? LocService.t("label_activate_all_desc_filtered") : LocService.t("label_activate_all_desc")
    var messageDeactivate = isFiltered ? LocService.t("label_deactivate_all_desc_filtered") : LocService.t("label_deactivate_all_desc")
    swal({
        title: LocService.t("label_are_you_sure"),
        text: value ? messageActivate : messageDeactivate,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            active: value,
            ids: _self.filteredSlots.map(e => e.id)
        }
        AdminApiService.activateDeactivateSlots(model)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
                _self.load()
            })
            .catch((error) => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}


// WEBPACK FOOTER //
// ./src/components/Trainings/View/ViewTrainings.js